import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { login } from "apa/actions";
import { Alert } from "reactstrap";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Button,
  Col,
  Container,
  Input,
  ListGroup,
  Progress,
  Row,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { Redirect } from "react-router-dom";
import { Presentation } from "apa/containers/Presentation";
import Dialog from "apa/containers/Dialog";
import TextArea from "apa/components/TextArea";
import Loading from "apa/components/Loading";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import Hover from "../components/Hover";

const Answer = (props) => {
  const { answer } = props;
  const correct = answer.selected === answer.correct;
  const highlight = (correct && answer.selected) || !correct;

  const getClass = (correct, highlight) => {
    if (highlight) {
      return correct ? "alert-success" : "alert-danger";
    }
    return "";
  };
  const className = getClass(correct, highlight);
  return (
    <div className={`alert ${className} answer-alert`} role="alert">
      <div className={"answer-checkmark"}>
        {answer.selected && <i className="fas fa-check"> </i>}
      </div>
      <div className={"answer-text"}>{answer.text}</div>
    </div>
  );
};

export const CodeDetails = (props) => {
  const { codeDetails } = props;
  const hideID = props.hideID;
  const isAuthenticated = props.isAuthenticated;

  return (
    <Fragment>
      {!hideID && !isAuthenticated && (
        <Fragment>
          <p>Name: {codeDetails?.additionalinformation?.name}</p>
          <p>Personalnummer: {codeDetails?.additionalinformation?.phone_num}</p>
        </Fragment>
      )}
      {codeDetails.results && codeDetails.results.results && (
        <h2>Auswertung</h2>
      )}
      {codeDetails.results &&
        codeDetails.results.results &&
        codeDetails.results.results.map((result, index) => (
          <div key={`question_key_${index}`} className={"question-container"}>
            <p className={"question-text"}>
              {index + 1}. {result.text}
            </p>
            {result.answers.map((answer, index) => (
              <Answer key={`answer_key_${index}`} answer={answer} />
            ))}
            {result.alternative && (
              <p className={"text-muted question-explanation"}>
                {result.alternative}
              </p>
            )}
          </div>
        ))}
    </Fragment>
  );
};

export const MessageDetails = (props) => {
  const { codeDetailsForMessage } = props;
  const hideID = props.hideID;
  return (
    <Fragment>
      {!hideID && (
        <Fragment>
          <p>Name: {codeDetailsForMessage?.additionalinformation?.name}</p>
          <p>
            Personalnummer:{" "}
            {codeDetailsForMessage?.additionalinformation?.phone_num}
          </p>
          <p>
            Kontaktdaten: {codeDetailsForMessage?.interview?.contactdetails}
          </p>
        </Fragment>
      )}
      <div style={{ backgroundColor: "#2d7691", padding: 6, borderRadius: 4 }}>
        <h5 style={{ color: "white" }}>Nachricht des Teilnehmers:</h5>
        <Fragment>
          <p style={{ color: "white" }}>
            {codeDetailsForMessage?.interview?.message}
          </p>
        </Fragment>
      </div>
    </Fragment>
  );
};

const overview = {
  customer: "",
  name: "",
  description: "",
  start_at: "",
  end_at: "",
  access_codes: [],
  data: [],
  is_invited: false,
  is_credentials_sent: false,
  released: false,
  released_at: "",
};

@connect(
  (state) => ({
    errors: state.apa.errors,
    isAuthenticated: state.apa.isAuthenticated,
    isSuperUser: state.apa.isSuperUser,
    token: state.apa.token,
  }),
  (dispatch) => ({
    login: (username, password) => dispatch(login(username, password)),
  })
)
export default class TrainingOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      overview: overview,
      codeDetails: null,
      isReleaseModalOpen: false,
      isSendModalOpen: false,
      isCredentialsModalOpen: false,
      newPresentationFile: "",
      newPresentationModal: false,
      isUploading: false,
      newCodes: 1,
      isInvited: false,
      isCredentialsSent: false,
      participantCodes: [],
      enableDownloadCodes: [],
      enableEmailCodes: [],
      isAllPDFDownloadAllowed: true,
      isAllAccessDataSentAllowed: false,
      isAllInvited: false,
      codeDetailsForMessage: null,
      isAllPDFDownloaded: false,
      selectedFile: null,
      isError: false,
      ErrorMessage: "",
      endDate: overview.end_at,
      showPopup: false,
    };
  }

  saveEndDate = () => {
    const uuid = this.props.match.params.uuid;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    const body = JSON.stringify({
      end_at: this.state.endDate,
    });
    fetch(`${BaseUrl}/api/customers/training/${uuid}/update-end-date/`, {
      headers,
      method: "PATCH",
      body,
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState((prevState) => ({
          overview: {
            ...prevState.overview,
            end_at: res.end_at,
          },
          message: {
            text: "Änderungen gespeichert.",
            color: "success",
          },
          isOpen: true,
        }));
        setTimeout(() => {
          this.setState({ isOpen: false });
        }, 5000);
      })
      .catch(() => {
        this.setState({
          message: {
            text: "Fehler beim Speichern der Änderungen.",
            color: "danger",
          },
          isOpen: true,
        });

        // Automatically dismiss the alert after 5 seconds
        setTimeout(() => {
          this.setState({ isOpen: false });
        }, 5000);
      });
  };

  onDismiss = () => {
    this.setState({ isOpen: false });
  };
  componentDidMount() {
    const uuid = this.props.match.params.uuid;
    const headers = {
      "Content-Type": "application/json",
    };
    fetch(`${BaseUrl}/api/customers/training/${uuid}/`, { headers })
      .then((res) => res.json())
      .then((res) => {
        let CodesDownload = [];
        let CodesEmail = [];
        res.access_codes.map((item) => {
          const isNameFilled =
            item.additionalinformation.name !== null &&
            item.additionalinformation.name !== "";
          const isPhoneFilled =
            item.additionalinformation.phone_num !== null &&
            item.additionalinformation.phone_num !== "";
          const isEmailFilled =
            item.additionalinformation.email !== null &&
            item.additionalinformation.email !== "";
          const isDownloadPDFAllowed = isNameFilled || isPhoneFilled;
          const isEmailSendAllowed =
            (isNameFilled || isPhoneFilled) && isEmailFilled;
          if (item.is_released == false) {
            this.setState({
              isAllPDFDownloaded: true,
            });
          }
          if (isDownloadPDFAllowed) {
            CodesDownload.push(item.code);
          } else {
            this.setState({
              isAllPDFDownloadAllowed: false,
            });
          }
          if (isEmailSendAllowed) {
            CodesEmail.push(item.code);
          }
        });

        const isAllAccessDataSentAllowed = res.access_codes.some((item) => {
          return (
            item.additionalinformation.email !== "" &&
            item.additionalinformation.email !== null &&
            ((item.additionalinformation.name !== "" &&
              item.additionalinformation.name !== null) ||
              (item.additionalinformation.phone_num !== "" &&
                item.additionalinformation.phone_num !== null))
          );
        });

        const notInvitedWithEmail = res.access_codes.filter(
          (item) =>
            !item.is_invited &&
            item.additionalinformation.email !== "" &&
            item.additionalinformation.email !== null
        );

        const isAllInvited = notInvitedWithEmail.length === 0;

        this.setState({
          endDate: res.end_at,
          overview: res,
          enableDownloadCodes: CodesDownload,
          enableEmailCodes: CodesEmail,
          isAllAccessDataSentAllowed: isAllAccessDataSentAllowed,
          isAllInvited: isAllInvited,
        });
      });
  }

  render() {
    /* Redirect to Login page, if logged in user is a participant (not a SuperUser aka. Gordon) */
    if (this.props.isAuthenticated) {
      if (!this.props.isSuperUser) {
        console.log("You are a participant. Redirect to Login.");
        return <Redirect to="/login" />;
      }
    }
    const overview = this.state.overview;
    /* console.log({ overview }); */
    const slides = overview.presentation_slides || [];

    const updateName = (value, code, name) => {
      const CodesDownload = this.state.enableDownloadCodes;
      const CodesEmail = this.state.enableEmailCodes;
      const uuid = this.props.match.params.uuid;
      const headers = {
        "Content-Type": "application/json",
      };
      const body = JSON.stringify({
        access_code: code.code,
        name: value,
      });
      fetch(`${BaseUrl}/api/customers/training/${uuid}/update_code/`, {
        headers,
        method: "POST",
        body,
      }).then((res) => {
        overview.access_codes.map((item) => {
          if (
            item.additionalinformation.access_code ===
            code.additionalinformation.access_code
          ) {
            item.additionalinformation.name = value;
            const isNameFilled = value !== "";
            const isPhoneFilled =
              item.additionalinformation.phone_num !== null &&
              item.additionalinformation.phone_num !== "";
            const isEmailFilled =
              item.additionalinformation.email !== null &&
              item.additionalinformation.email !== "";
            const isDownloadPDFAllowed = isNameFilled || isPhoneFilled;
            if (isDownloadPDFAllowed) {
              if (
                (isNameFilled || isPhoneFilled) &&
                !CodesDownload.includes(code?.code)
              ) {
                CodesDownload.push(code?.code);
              }
              if (
                (isNameFilled || isPhoneFilled) &&
                isEmailFilled &&
                !CodesEmail.includes(code?.code)
              ) {
                CodesEmail.push(code?.code);
              }
            } else {
              const codeIndex = CodesDownload.indexOf(code?.code);
              if (codeIndex !== -1) {
                CodesDownload.splice(codeIndex, 1);
              }
              const emailCodeIndex = CodesEmail.indexOf(code?.code);
              if (emailCodeIndex !== -1) {
                CodesEmail.splice(emailCodeIndex, 1);
              }
              this.setState({
                enableDownloadCodes: CodesDownload,
                enableEmailCodes: CodesEmail,
              });
            }
          }
        });

        const isAllPDFDownloadAllowed = overview.access_codes.every((item) => {
          //const isNameFilled = value !== "";
          const isNameFilled = item.additionalinformation.name !== "";
          const isPhoneFilled = item.additionalinformation.phone_num !== "";
          const isDownloadPDFAllowed = isNameFilled || isPhoneFilled;
          return isDownloadPDFAllowed && CodesDownload.includes(item.code);
        });

        const isAllAccessDataSentAllowed = overview.access_codes.some(
          (item) => {
            return (
              item.additionalinformation.email !== "" &&
              item.additionalinformation.email !== null &&
              ((item.additionalinformation.name !== "" &&
                item.additionalinformation.name !== null) ||
                (item.additionalinformation.phone_num !== "" &&
                  item.additionalinformation.phone_num !== null))
            );
          }
        );

        this.setState({
          isAllAccessDataSentAllowed: isAllAccessDataSentAllowed,
          isAllPDFDownloadAllowed: isAllPDFDownloadAllowed,
        });
      });
    };
    const updateEmail = (value, code, name) => {
      const uuid = this.props.match.params.uuid;
      const CodesEmail = this.state.enableEmailCodes;
      const headers = {
        "Content-Type": "application/json",
      };
      const body = JSON.stringify({
        access_code: code.code,
        email: value,
      });
      fetch(`${BaseUrl}/api/customers/training/${uuid}/update_code/`, {
        headers,
        method: "POST",
        body,
      }).then((res) => {
        console.log("Update Email Response", res);

        const updatedAccessCodes = overview.access_codes.map((item) => {
          if (item.code === code.code) {
            return {
              ...item,
              additionalinformation: {
                ...item.additionalinformation,
                email: value,
              },
            };
          }
          return item;
        });

        updatedAccessCodes.map((item) => {
          if (
            item.additionalinformation.access_code ===
            code.additionalinformation.access_code
          ) {
            const isNameFilled =
              item.additionalinformation.name !== null &&
              item.additionalinformation.name !== "";
            const isPhoneFilled =
              item.additionalinformation.phone_num !== null &&
              item.additionalinformation.phone_num !== "";
            const isEmailFilled =
              item.additionalinformation.email !== null &&
              item.additionalinformation.email !== "";

            if ((isNameFilled || isPhoneFilled) && isEmailFilled) {
              if (!CodesEmail.includes(code?.code)) {
                CodesEmail.push(code?.code);
              }
            } else {
              const emailCodeIndex = CodesEmail.indexOf(code?.code);
              if (emailCodeIndex !== -1) {
                CodesEmail.splice(emailCodeIndex, 1);
              }
              this.setState({
                enableEmailCodes: CodesEmail,
              });
            }
          }
        });

        const isAllAccessDataSentAllowed = updatedAccessCodes.some((item) => {
          return (
            item.additionalinformation.email !== "" &&
            item.additionalinformation.email !== null &&
            ((item.additionalinformation.name !== "" &&
              item.additionalinformation.name !== null) ||
              (item.additionalinformation.phone_num !== "" &&
                item.additionalinformation.phone_num !== null))
          );
        });

        this.setState({
          isAllAccessDataSentAllowed: isAllAccessDataSentAllowed,
          overview: {
            ...overview,
            access_codes: updatedAccessCodes,
          },
        });

        const notInvitedWithEmail = updatedAccessCodes.filter(
          (item) =>
            !item.is_invited &&
            item.additionalinformation.email !== "" &&
            item.additionalinformation.email !== null
        );

        const emailAddedElement = updatedAccessCodes.find(
          (item) => item.code === code.code
        );

        if (
          emailAddedElement &&
          !emailAddedElement.is_invited &&
          emailAddedElement.additionalinformation.email &&
          value
        ) {
          this.setState({
            isAllInvited: false,
          });
        } else {
          this.setState({
            isAllInvited: notInvitedWithEmail.length === 0,
          });
        }
      });
    };

    const updateFunction = (value, code, name) => {
      const uuid = this.props.match.params.uuid;
      const headers = {
        "Content-Type": "application/json",
      };
      const body = JSON.stringify({
        access_code: code.code,
        function: value,
      });
      fetch(`${BaseUrl}/api/customers/training/${uuid}/update_code/`, {
        headers,
        method: "POST",
        body,
      });
    };
    const updatePersonalNum = (value, code, name) => {
      const CodesDownload = this.state.enableDownloadCodes;
      const CodesEmail = this.state.enableEmailCodes;
      const uuid = this.props.match.params.uuid;
      const headers = {
        "Content-Type": "application/json",
      };
      const body = JSON.stringify({
        access_code: code.code,
        phone_num: value,
      });
      fetch(`${BaseUrl}/api/customers/training/${uuid}/update_code/`, {
        headers,
        method: "POST",
        body,
      }).then((res) => {
        overview.access_codes.map((item) => {
          if (
            item.additionalinformation.access_code ===
            code.additionalinformation.access_code
          ) {
            item.additionalinformation.phone_num = value;
            const isNameFilled =
              item.additionalinformation.name !== null &&
              item.additionalinformation.name !== "";
            const isPhoneFilled = value !== "";
            const isEmailFilled =
              item.additionalinformation.email !== null &&
              item.additionalinformation.email !== "";
            const isDownloadPDFAllowed = isNameFilled || isPhoneFilled;
            if (isDownloadPDFAllowed) {
              if (
                (isNameFilled || isPhoneFilled) &&
                !CodesDownload.includes(code?.code)
              ) {
                CodesDownload.push(code?.code);
              }
              if (
                (isNameFilled || isPhoneFilled) &&
                isEmailFilled &&
                !CodesEmail.includes(code?.code)
              ) {
                CodesEmail.push(code?.code);
              }
            } else {
              const codeIndex = CodesDownload.indexOf(code?.code);
              if (codeIndex !== -1) {
                CodesDownload.splice(codeIndex, 1);
              }
              const emailCodeIndex = CodesEmail.indexOf(code?.code);
              if (emailCodeIndex !== -1) {
                CodesEmail.splice(emailCodeIndex, 1);
              }
              this.setState({
                enableDownloadCodes: CodesDownload,
                enableEmailCodes: CodesEmail,
              });
            }
          }
        });

        const isAllPDFDownloadAllowed = overview.access_codes.every((item) => {
          const isNameFilled = item.additionalinformation.name !== "";
          const isPhoneFilled = item.additionalinformation.phone_num !== "";
          // const isPhoneFilled = value !== "";
          const isDownloadPDFAllowed = isNameFilled || isPhoneFilled;
          return isDownloadPDFAllowed && CodesDownload.includes(item.code);
        });

        const isAllAccessDataSentAllowed = overview.access_codes.some(
          (item) => {
            return (
              item.additionalinformation.email !== "" &&
              item.additionalinformation.email !== null &&
              ((item.additionalinformation.name !== "" &&
                item.additionalinformation.name !== null) ||
                (item.additionalinformation.phone_num !== "" &&
                  item.additionalinformation.phone_num !== null))
            );
          }
        );

        this.setState({
          isAllAccessDataSentAllowed: isAllAccessDataSentAllowed,
          isAllPDFDownloadAllowed: isAllPDFDownloadAllowed,
        });
      });
    };
    const releaseTraining = () => {
      const uuid = this.props.match.params.uuid;
      const headers = {
        "Content-Type": "application/json",
      };
      const body = JSON.stringify({
        uuid: uuid,
      });
      fetch(`${BaseUrl}/api/customers/training/${uuid}/release/`, {
        headers,
        method: "POST",
        body,
      })
        .then((res) => res.json())
        .then((res) => {
          this.setState({ overview: res });

          window.location.reload();
        });
    };

    const toggleReleaseModal = () => {
      this.setState({
        isReleaseModalOpen: !this.state.isReleaseModalOpen,
      });
    };

    const toggleSendModal = () => {
      this.setState({
        isSendModalOpen: !this.state.isSendModalOpen,
      });
    };

    const toggleSendCredentialsModal = () => {
      this.setState({
        isCredentialsModalOpen: !this.state.isCredentialsModalOpen,
      });
    };

    const sendInvitation = () => {
      const uuid = this.props.match.params.uuid;
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${this.props.token}`,
      };
      const body = JSON.stringify({
        uuid: uuid,
      });
      fetch(
        `${BaseUrl}/api/customers/training/${uuid}/send_responsible_person_invitation/`,
        {
          headers,
          method: "POST",
          body,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.setState({ overview: res });
          this.setState({
            isInvited: true,
          });
        });
    };

    // const sendCredentials = () => {
    //   const uuid = this.props.match.params.uuid;
    //   const headers = {
    //     "Content-Type": "application/json",
    //     Authorization: `Token ${this.props.token}`,
    //   };
    //   const body = JSON.stringify({
    //     uuid: uuid,
    //   });
    //   fetch(`${BaseUrl}/api/customers/training/${uuid}/send_credentials/`, {
    //     headers,
    //     method: "POST",
    //     body,
    //   })
    //     .then((res) => res.json())
    //     .then(
    //       this.setState({
    //         isCredentialsSent: true,
    //       })
    //     );
    // };

    const toggleCodeDetails = (code) => {
      this.setState({
        codeDetails: this.state.codeDetails ? null : code,
      });
    };

    const { codeDetails } = this.state || {};

    const toggleMessageDetails = (code) => {
      this.setState({
        codeDetailsForMessage: this.state.codeDetailsForMessage ? null : code,
      });
    };

    const { codeDetailsForMessage } = this.state || {};

    const displayResultsCol = (results) => {
      if (Object.prototype.hasOwnProperty.call(results, "correct")) {
        return (
          <span>
            {results.correct} / {results.max} ({Math.round(results.percentage)}{" "}
            %)
          </span>
        );
      }
      return null;
    };

    const updateTraining = (event) => {
      const fieldName = event.target.name;
      const fieldValue = event.target.value;

      const overview = { ...this.state.overview, [fieldName]: fieldValue };

      this.setState({
        overview: overview,
      });
    };

    const saveTraining = () => {
      const uuid = this.props.match.params.uuid;
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${this.props.token}`,
      };
      const overview = { ...this.state.overview };
      delete overview.codes_file;
      delete overview.presentation;
      const body = JSON.stringify(overview);
      fetch(`${BaseUrl}/api/customers/training/${uuid}/`, {
        headers,
        method: "PATCH",
        body,
      })
        .then((res) => res.json())
        .then((res) => this.setState({ overview: res }));
    };

    const addCodes = () => {
      const uuid = this.props.match.params.uuid;
      const number_of_codes = this.state.newCodes;
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${this.props.token}`,
      };
      const body = JSON.stringify({
        uuid: uuid,
        number_of_codes: number_of_codes,
      });
      fetch(`${BaseUrl}/api/customers/training/${uuid}/add_code/`, {
        headers,
        method: "POST",
        body,
      })
        .then((res) => res.json())
        .then(() => window.location.reload());
    };

    const toggleUploadConfirmation = () => {
      this.setState({ newPresentationModal: !this.state.newPresentationModal });
    };

    const confirmUpload = () => {
      const uuid = this.props.match.params.uuid;
      this.setState({ isUploading: true });
      const headers = {
        Authorization: `Token ${this.props.token}`,
      };
      const body = new FormData();
      body.append("presentation", this.state.newPresentationFile);
      fetch(`${BaseUrl}/api/customers/training/${uuid}/`, {
        headers,
        method: "PATCH",
        body,
      })
        .then((res) => res.json())
        .then(() => window.location.reload());
    };

    const handleFileChange = ({ target: { files } }) => {
      const cancel = !files.length;
      if (cancel) return;

      const file = files[0];
      if (file.name.endsWith(".pptx")) {
        this.setState({ newPresentationFile: file, invalidFile: false });
        toggleUploadConfirmation();
      } else {
        this.setState({ newPresentationFile: "", invalidFile: true });
      }
    };

    const SendParticipantInvitation = (accessCode) => {
      const Codes = this.state.participantCodes;
      fetch(
        `${BaseUrl}/api/trainings/access_codes/${accessCode}/send_invitation/`,
        { method: "POST" }
      )
        .then((res) => res.json())
        .then((res) => {
          console.log("SendParticipantInvitation", res);
          Codes.push(res?.code);

          const updatedAccessCodes = overview.access_codes.map((item) =>
            item.code === res.code ? res : item
          );

          const notInvitedWithEmail = updatedAccessCodes.filter(
            (item) =>
              !item.is_invited &&
              (item.additionalinformation.email === "" ||
                item.additionalinformation.email === null)
          );

          const InvitedWithEmail = updatedAccessCodes.filter(
            (item) =>
              item.is_invited &&
              (item.additionalinformation.email !== "" ||
                item.additionalinformation.email !== null)
          );

          const isAllInvited = notInvitedWithEmail.length === 0;

          this.setState({
            participantCodes: Codes,
            isAllInvited: isAllInvited || InvitedWithEmail,
            overview: {
              ...overview,
              access_codes: updatedAccessCodes,
            },
          });
        });
    };

    const HandleDownloadFile = (accessCode) => {
      fetch(
        `${BaseUrl}/api/trainings/access_codes/${accessCode}/download_access_file/`,
        { method: "POST" }
      )
        .then((res) => res.json())
        .then((res) => {
          window.open(`${BaseUrl}${res.invitation_file}`, "_blank");
          window.location.reload();
        });
    };

    const HandleDownloadAllFile = (trainingId) => {
      fetch(
        `${BaseUrl}/api/customers/training/${trainingId}/create_credentials_file/`,
        { method: "POST" }
      )
        .then((res) => res.json())
        .then((res) => {
          window.open(`${BaseUrl}${res.codes_file}`, "_blank");
          window.location.reload();
        });
    };

    const SendAllParticipantInvitation = (trainingId) => {
      fetch(
        `${BaseUrl}/api/customers/training/${trainingId}/send_users_invitations/`,
        { method: "POST" }
      )
        .then((res) => res.json()) // convert the response to a JSON object
        .then((data) => {
          console.log("SendAllParticipantInvitation", data);

          if (data) {
            let CodesEmail = [];
            data.access_codes.map((item) => {
              const isNameFilled =
                item.additionalinformation.name !== null &&
                item.additionalinformation.name !== "";
              const isPhoneFilled =
                item.additionalinformation.phone_num !== null &&
                item.additionalinformation.phone_num !== "";
              const isEmailFilled =
                item.additionalinformation.email !== null &&
                item.additionalinformation.email !== "";
              const isEmailSent =
                (isNameFilled || isPhoneFilled) &&
                isEmailFilled &&
                item.is_invited;
              if (isEmailSent) {
                CodesEmail.push(item.code);
              }
            });

            console.log({ CodesEmail });
            this.setState({
              overview: data,
              participantCodes: CodesEmail,
              isAllInvited: true,
            });
          }
        })
        .catch((error) => {
          // handle error case here
        });
    };

    const can_edit = this.props.isAuthenticated;

    const Change_Uplaod = (e) => {
      if (e.target.files.length > 0) {
        this.setState({
          selectedFile: e.target.files[0],
        });
      }
    };

    // `${BaseUrl}/api/customers/training/import_participants/`
    const Upload_files = async () => {
      console.log(this.state.selectedFile);
      const uuid = this.props.match.params.uuid;
      if (this.state.selectedFile !== null) {
        const formData = new FormData();
        formData.append("participants", this.state.selectedFile);

        const response = await fetch(
          `${BaseUrl}/api/customers/training/${uuid}/import_participants/`,
          {
            method: "POST",
            body: formData,
          }
        );
        const data = await response.json();

        if (response.status == 400) {
          this.setState({
            ErrorMessage: data.detail,
            isError: true,
          });
        } else {
          window.location.reload();
        }
      }
    };

    return (
      <Container>
        {this.state.message && (
          <div
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
              minWidth: "300px",
            }}
          >
            <Alert
              color={this.state.message.color}
              isOpen={this.state.isOpen}
              toggle={this.onDismiss}
            >
              {this.state.message.text}
            </Alert>
          </div>
        )}
        <h1>{overview.name}</h1>
        <h2>{overview.customer_name}</h2>
        {/* <h2>{overview.available_access_codes }{overview.end_at}</h2> */}

        <p>
          <div style={{ marginTop: "15px" }}>
            <h6>Start</h6>
          </div>
          <Input
            name="start_at"
            type="date"
            label="Start"
            value={this.state.overview.start_at}
            disabled={true}
          />
          <Fragment>
            <div style={{ marginTop: "15px" }}>
              <h6>Ende</h6>
              <Input
                name="end_at"
                type="date"
                label="Ende"
                value={this.state.endDate}
                onChange={(e) => {
                  this.setState({ endDate: e.target.value });
                }}
                onBlur={this.saveEndDate}
                disabled={!can_edit}
              />
            </div>
          </Fragment>
        </p>
        <h3>Vorschau der Präsentation</h3>
        <Presentation items={slides} />
        <br />
        {can_edit && (
          <FormGroup>
            <CustomInput
              type="file"
              id="exampleCustomFileBrowser"
              name="customFile"
              label={
                this.state.newPresentationFile || "Schulungs .pptx ersetzen"
              }
              onChange={handleFileChange}
              invalid={this.state.invalidFile}
            />
            <Dialog
              isOpen={this.state.newPresentationModal}
              toggle={toggleUploadConfirmation}
              confirm={confirmUpload}
              title={"Schulungspersentation ersetzen"}
            >
              Das kann einige Augenblicke dauern.
              {this.state.isUploading && <Loading />}
            </Dialog>
          </FormGroup>
        )}
        <h3>Themenübersicht</h3>
        <TextArea
          disabled={!can_edit}
          onChange={updateTraining}
          onBlur={saveTraining}
          name="description"
          value={overview.description}
        />
        <br />
        <h3>Fragenzanzahl zu folgenden Themen</h3>
        <ListGroup>
          {overview.data.map((question) => (
            <Row className="mt-1" key={`question_selection_${question.id}`}>
              <Col>
                <strong>{question.label}</strong>
              </Col>
              <Col>
                <Input
                  disabled
                  style={{ backgroundColor: "#DFDFDF" }}
                  placeholder="Fragen"
                  type="number"
                  min={1}
                  defaultValue={question.number}
                />
              </Col>
            </Row>
          ))}
        </ListGroup>
        <div>
          <h3>Statistiken</h3>
          <h4>Übersicht der Registrierungen</h4>
          <Progress multi>
            <Progress bar color="success" value={overview.registered}>
              Registriert ({Math.round(overview.registered)} %)
            </Progress>
            <Progress bar color="info" value={overview.not_used}>
              Offen ({Math.round(overview.not_used)} %)
            </Progress>
          </Progress>
          <br />
          <h4>Ergebnisse der Wissenskontrolle</h4>
          <Progress multi>
            <Progress bar color="success" value={overview.success}>
              Bestanden ({Math.round(overview.success)} %)
            </Progress>
            <Progress bar color="danger" value={overview.fail}>
              Teilgen. ({Math.round(overview.fail)} %)
            </Progress>
            <Progress
              bar
              color="secondary"
              value={
                100 -
                overview.fail -
                overview.repeat -
                overview.no -
                overview.success
              }
            >
              In Arbeit (
              {Math.round(
                100 -
                  overview.fail -
                  overview.repeat -
                  overview.no -
                  overview.success
              )}{" "}
              %)
            </Progress>
            <Progress bar color="warning" value={overview.repeat}>
              Nicht abgeschl. ({Math.round(overview.repeat)} %)
            </Progress>
            <Progress bar color="info" value={overview.no}>
              Nicht teilgen. ({Math.round(overview.no)} %)
            </Progress>
          </Progress>
          <br />
          <h3>Übersicht der Zugangscodes</h3>
          <p>
            <strong>
              Hier müssen die Zugangscodes zu den Mitarbeitern zugeordnet
              werden.
            </strong>
          </p>
          {can_edit && (
            <FormGroup row>
              <Col sm={12}>
                <Input
                  style={{ width: "5em", float: "left" }}
                  type="number"
                  min={1}
                  max={10}
                  value={this.state.newCodes}
                  onChange={(e) => this.setState({ newCodes: e.target.value })}
                />
                <Button onClick={addCodes} color={"primary"}>
                  <i className="fa fa-plus"> </i> Zugangscodes hinzufügen
                </Button>
              </Col>
            </FormGroup>
          )}

          {!can_edit && (
            <>
              <p>
                <strong>Legende:</strong> <span className="text-danger">*</span>{" "}
                Pflichtfeld - (Eins von beiden ist notwendig)&nbsp;&nbsp;
                <span className="text-danger">#</span> /{" "}
                <span className="text-danger">+</span> kein Pflichtfeld
              </p>
              <p>
                <span className="text-danger">*</span> - Zuordnung der
                Zugangscodes durch Namen und/oder Personalnummer
                <br />
                <span className="text-danger">+</span> - Die Einladung der
                Teilnehmer können Sie nach Eintrag der E-Mail-Adresse direkt an
                diese versenden. Nach Versand der E-Mail an den Teilnehmer
                ändert sich die Farbe von grau in grün. (ist versandt)
                <br />
                <span className="text-danger">#</span> - Bei Bedarf zusätzliche
                Gruppierung möglich: (Funktion / Abteilung / Tätigkeit)
              </p>
            </>
          )}
          <div>
            {/* Description of the import process */}
            <div className="import-instructions">
              <h5>Import der Zugangscodes</h5>
              <p>
                Um Zugangscodes für die Schulungsteilnehmer zu importieren,
                laden Sie bitte die folgende CSV-Datei herunter. Diese Datei
                dient als Vorlage, um die Teilnehmerdaten korrekt zu erfassen:
              </p>

              {/* Download link for CSV file */}
              <a href="/media/downloads/Teilnehmer_Schulung.csv" download>
                <button
                  style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    width: "15rem",
                    height: "2.5rem",
                    borderRadius: "5px",
                    border: "none",
                  }}
                >
                  Beispieldatei herunterladen
                </button>
              </a>

              <p className="mt-3">
                Bitte fügen Sie in die CSV-Datei die benötigten Teilnehmerdaten
                wie Name, Personalnummer und E-Mail ein. Nachdem Sie die Datei
                ausgefüllt haben, können Sie sie hier hochladen.
              </p>
            </div>

            {/* CSV upload section */}
            <input
              type="file"
              name="participants"
              accept=".csv"
              onChange={(e) => {
                this.setState({ isError: false });
                Change_Uplaod(e);
              }}
              onClick={() => {
                this.setState({ isError: false });
              }}
            />

            <button
              onClick={Upload_files}
              style={{
                backgroundColor:
                  overview.available_access_codes === 0 ||
                  new Date(overview.end_at) > new Date()
                    ? "#6c757d"
                    : "#007bff",
                color: "white",
                width: "7rem",
                height: "2.5rem",
                borderRadius: "5px",
                border: "none",
              }}
              disabled={
                overview.available_access_codes === 0 ||
                new Date(overview.end_at) > new Date()
              }
              title="Teilnehmerdaten als CSV Datei hochladen"
            >
              Hochladen
            </button>

            {/* Shows error messages if import failed */}
            {this.state.isError && (
              <div style={{ color: "red" }}>{this.state.ErrorMessage}</div>
            )}
          </div>
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: "20px" }} />
                <th>Zugangscode</th>
                {can_edit && <th>Erstellt am</th>}
                {!can_edit && (
                  <>
                    <th style={{ width: "190px" }}>
                      Name <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: "100px" }} title="Personalnummer">
                      Pers. Nr. <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: "215px" }}>
                      E-Mail <span className="text-danger">+</span>
                    </th>
                    <th
                      style={{ width: "120px" }}
                      title="Funktion im Unternehmen"
                    >
                      Funktion <span className="text-danger">#</span>
                    </th>
                  </>
                )}
                <th
                  className={"text-center"}
                  style={{ width: "60px" }}
                  title="Zugangscode wurde benutzt"
                >
                  Ben.
                </th>
                <th
                  className={"text-center"}
                  style={{ width: "60px" }}
                  title="Teilnehmer hat bestanden"
                >
                  Best.
                </th>
                <th
                  className={"text-center"}
                  style={{ width: "80px" }}
                  title="Erreichte Punktzahl"
                >
                  Punkte
                </th>
                {can_edit && (
                  <>
                    <th style={{ width: "66px" }}></th>
                  </>
                )}
                <th style={{ width: "66px" }}></th>
                <th style={{ width: "97px" }}></th>
              </tr>
            </thead>
            <tbody>
              {overview.access_codes.map((code, idx) => (
                <tr
                  key={`code_${idx}`}
                  style={{
                    color:
                      can_edit &&
                      overview.released &&
                      new Date(code.created_at) >
                        new Date(overview.released_at) &&
                      "red",
                  }}
                >
                  <td>{idx + 1}.</td>
                  <td>{code.code}</td>
                  {can_edit && (
                    <td>
                      {code?.created_at
                        ? new Date(code.created_at).toLocaleDateString(
                            "de-DE",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )
                        : ""}
                    </td>
                  )}
                  {!can_edit && (
                    <>
                      <td>
                        {code.user == null ? (
                          <Input
                            defaultValue={code.additionalinformation?.name}
                            onBlur={(e) =>
                              updateName(e.target.value, code, "name")
                            }
                            className={`${
                              this.state.enableDownloadCodes.includes(
                                code?.code
                              )
                                ? code?.is_released
                                  ? ""
                                  : ""
                                : "is-invalid"
                            }`}
                          />
                        ) : (
                          <Input
                            disabled
                            style={{ backgroundColor: "#DFDFDF" }}
                            defaultValue={code.additionalinformation?.name}
                          />
                        )}
                      </td>
                      <td>
                        {code.user == null ? (
                          <Input
                            defaultValue={code.additionalinformation?.phone_num}
                            onBlur={(e) =>
                              updatePersonalNum(
                                e.target.value,
                                code,
                                "phone_num"
                              )
                            }
                            className={`${
                              this.state.enableDownloadCodes.includes(
                                code?.code
                              )
                                ? code?.is_released
                                  ? ""
                                  : ""
                                : "is-invalid"
                            }`}
                          />
                        ) : (
                          <Input
                            disabled
                            style={{ backgroundColor: "#DFDFDF" }}
                            defaultValue={code.additionalinformation?.phone_num}
                          />
                        )}
                      </td>
                      <td>
                        {code.user == null ? (
                          <Input
                            defaultValue={code.additionalinformation?.email}
                            onBlur={(e) =>
                              updateEmail(e.target.value, code, "email")
                            }
                          />
                        ) : (
                          <Input
                            disabled
                            style={{ backgroundColor: "#DFDFDF" }}
                            defaultValue={code.additionalinformation?.email}
                          />
                        )}
                      </td>
                      <td>
                        {code.user == null ? (
                          <Input
                            defaultValue={code.additionalinformation?.function}
                            onBlur={(e) =>
                              updateFunction(e.target.value, code, "function")
                            }
                          />
                        ) : (
                          <Input
                            disabled
                            style={{ backgroundColor: "#DFDFDF" }}
                            defaultValue={code.additionalinformation?.function}
                          />
                        )}
                      </td>
                    </>
                  )}
                  <td className={"text-center"}>
                    {!code.user && <i className={"fa fa-times"}> </i>}
                    {code.user && <i className={"fa fa-check"}> </i>}
                  </td>
                  <td className={"text-center"}>
                    {code.status != 3 && <i className={"fa fa-times"}> </i>}
                    {code.status == 3 && <i className={"fa fa-check"}> </i>}
                  </td>
                  <td className={"text-center"}>
                    {displayResultsCol(code.results)}
                  </td>
                  <td>
                    <Hover
                      sendToParticipant={true}
                      code={code}
                      SendParticipantInvitation={SendParticipantInvitation}
                      enableEmailCodes={this.state.enableEmailCodes}
                      participantCodes={this.state.participantCodes}
                    />
                    {/* <button
                      onClick={() => SendParticipantInvitation(code?.code)}
                      target="_blank"
                      // style={{
                      //   position:"relative"
                      // }}
                      referrerPolicy="no-referrer"
                      className={
                        this.state.enableEmailCodes.includes(code?.code) ? (
                          code?.is_invited ||
                          this.state.participantCodes.includes(code?.code)
                            ? "btn btn-success"
                            : "btn btn-primary")
                          : (
                              "btn btn-secondary"
                          )
                      }
                      disabled={
                        !this.state.enableEmailCodes.includes(code?.code)
                      }>
                      <i className="fa fa-envelope"> </i>
                    </button> */}
                  </td>

                  {can_edit && (
                    <>
                      <td>
                        <button
                          className={`${
                            this.state.enableDownloadCodes.includes(code?.code)
                              ? code?.is_released
                                ? "btn btn-success"
                                : "btn btn-primary"
                              : "btn btn-secondary"
                          }`}
                          disabled={
                            !this.state.enableDownloadCodes.includes(code?.code)
                          }
                          onClick={() => HandleDownloadFile(code?.code)}
                          target="_blank"
                          referrerPolicy="no-referrer"
                          data-toggle={
                            this.state.enableDownloadCodes.includes(code?.code)
                              ? ""
                              : "tooltip"
                          }
                          title={
                            this.state.enableDownloadCodes.includes(code?.code)
                              ? ""
                              : "Bitte geben Sie einen Namen oder eine Personalnummer ein"
                          }
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      </td>
                    </>
                  )}

                  <td>
                    <Button
                      color="primary"
                      onClick={() => toggleCodeDetails(code)}
                    >
                      Details
                    </Button>
                  </td>
                  {this.props.isAuthenticated && code.interview?.status && (
                    <td>
                      <Button
                        onClick={() => toggleMessageDetails(code)}
                        style={{
                          backgroundColor: "white",
                          color: "#2d7691",
                          borderRadius: 5,
                          borderColor: "#2d7691",
                        }}
                      >
                        <i className="fa fa-comments"></i>
                      </Button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          <Modal isOpen={codeDetails} toggle={toggleCodeDetails} size="lg">
            <ModalHeader toggle={toggleCodeDetails}>Details</ModalHeader>
            <ModalBody>
              {codeDetails && (
                <CodeDetails
                  codeDetails={codeDetails}
                  isAuthenticated={can_edit}
                />
              )}
            </ModalBody>
          </Modal>
          <Modal
            isOpen={codeDetailsForMessage}
            toggle={toggleMessageDetails}
            size="lg"
          >
            <ModalHeader toggle={toggleMessageDetails}>
              Persönliche Interviewanfrage
            </ModalHeader>
            <ModalBody>
              {codeDetailsForMessage && (
                <MessageDetails codeDetailsForMessage={codeDetailsForMessage} />
              )}
            </ModalBody>
          </Modal>
          <h3>Aktionen</h3>
          {/* FOR GORDON'S VIEW */}
          {can_edit && (
            <>
              <p>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                  }}
                  onMouseEnter={() => {
                    this.setState({ showPopup: true });
                  }}
                  onMouseLeave={() => {
                    this.setState({ showPopup: false });
                  }}
                >
                  <Button
                    href="#"
                    disabled={overview.released}
                    color={overview.released ? "success" : "primary"}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleReleaseModal();
                    }}
                  >
                    Schulung freigeben
                  </Button>
                  {overview.released && this.state.showPopup && (
                    <div
                      className="popup"
                      style={{
                        position: "absolute",
                        bottom: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        padding: "10px",
                        backgroundColor: "black",
                        color: "white",
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {new Date(overview.released_at)
                        .toLocaleDateString("de-DE", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                        .replace(" um", ",")}
                    </div>
                  )}
                </div>
                <Dialog
                  isOpen={this.state.isReleaseModalOpen}
                  toggle={toggleReleaseModal}
                  title={"Freigabe bestätigen"}
                  confirm={releaseTraining}
                />
              </p>
              <div>
                <Hover
                  sendToParticipant={false}
                  overview={overview}
                  isInvited={this.state.isInvited}
                  toggleSendModal={toggleSendModal}
                />
                {/* <Button
                  color={
                    overview?.is_invited || this.state.isInvited
                      ? "success"
                      : "primary"
                  }
                  onClick={toggleSendModal}>
                  <i className="fa fa-envelope"> </i>
                  &nbsp; Einladung an Verantwortlichen senden
                </Button> */}
                <Dialog
                  isOpen={this.state.isSendModalOpen}
                  toggle={toggleSendModal}
                  title={"Einladung an Verwantworlichen bestätigen"}
                  confirm={() => {
                    sendInvitation();
                    toggleSendModal();
                  }}
                />
              </div>
            </>
          )}
          {/* FOR RESPONSIBLE PERSON VIEW */}
          {!can_edit && (
            <>
              <p>
                {this.state.isAllPDFDownloaded ? (
                  <a
                    target="_blank"
                    onClick={() => HandleDownloadAllFile(overview?.uuid)}
                    referrerPolicy="no-referrer"
                    className={`btn ${
                      !this.state.isAllPDFDownloadAllowed
                        ? "btn-secondary disabled"
                        : "btn-primary"
                    }`}
                  >
                    <i className="fa fa-download"></i> &nbsp; Zugangsdaten
                    herunterladen
                  </a>
                ) : (
                  <a
                    target="_blank"
                    href={overview?.codes_file}
                    referrerPolicy="no-referrer"
                    className={`btn btn-success${
                      !this.state.isAllPDFDownloadAllowed ? " disabled" : ""
                    }`}
                  >
                    <i className="fa fa-download"></i> &nbsp; Zugangsdaten
                    herunterladen
                  </a>
                )}
              </p>
              <a
                onClick={() => SendAllParticipantInvitation(overview.uuid)}
                className={`btn ${
                  this.state.isAllInvited
                    ? !this.state.isAllAccessDataSentAllowed
                      ? "btn-success disabled"
                      : "btn-success"
                    : !this.state.isAllAccessDataSentAllowed
                    ? "btn-secondary disabled"
                    : "btn-primary"
                }`}
              >
                <i className="fa fa-envelope"> </i> &nbsp; Zugangsdaten an
                Teilnehmer senden
              </a>
            </>
          )}
          {/* {can_edit && (
            <p>
              <Button
                color={
                  overview?.is_credentials_sent || this.state.isCredentialsSent
                    ? "success"
                    : "primary"
                }
                onClick={toggleSendCredentialsModal}>
                <i className="fa fa-envelope"> </i>
                &nbsp; Anmeldedaten an verantwortliche Person senden
              </Button>
              <Dialog
                isOpen={this.state.isCredentialsModalOpen}
                toggle={toggleSendCredentialsModal}
                title={
                  "Bestätigen Sie die Anmeldeinformationen der verantwortlichen Person"
                }
                confirm={() => {
                  sendCredentials();
                  toggleSendCredentialsModal();
                }}
              />
            </p>
          )} */}
        </div>
      </Container>
    );
  }
}
